import { DateTime } from "luxon";

export const dateHelper = {
  addSeconds(dateObj, seconds) {
    /**
     * Add a number of days to a given Date
     * @argument dateObj {Date} A Date object
     * @argument days {Number} The number of seconds to be added
     * @returns {Date} A new Date object, with the days added
     */
    const timeObject = new Date(dateObj);
    const milliseconds = seconds * 1000; // 10 seconds = 10000 milliseconds
    return new Date(timeObject.getTime() + milliseconds);
  }
};

/**
 * Counteract Datepicker localization for UTC time
 * by subtracting local offset. Datepicker will then add
 * the offset back to the resulting value before rendering
 * @param {string} date ISO1086 utc timestamp
 * @returns {string} time with reversed offset
 */

export const dateTzOffset = (date) => {
  const stringDate = new Date(date).toISOString();
  const utcDate = DateTime.fromISO(stringDate, { zone: "utc" });
  const localDate = utcDate.setZone("local");
  // const { offset: localOffset } = utcDate.setZone("system", {
  //   keepLocalTime: true
  // });
  // const offsetDate = utcDate.minus({
  //   minutes: localOffset
  // });
  return localDate.toISO();
};

export const displayOnlyYear = (date) => {
  if (date) {
    const dt = DateTime.fromISO(date, { zone: "utc" });
    return dt.year;
  }
  return "";
};

export const convertToLocalTime = (inputDate) => {
  // Convert the input date to a string in ISO format (UTC)
  const utcString = new Date(inputDate).toISOString();
  const dateTime = DateTime.fromISO(inputDate);

  // Formatting the DateTime object to match the input format
  const formattedString = dateTime.toFormat("yyyy-MM-dd");

  const dateWithTime = formattedString !== inputDate;

  // Create a DateTime object from the ISO string, setting the initial zone to "utc"
  const utcDateTime = DateTime.fromISO(utcString, { zone: "utc" });

  // Set the zone to "system" (local time zone) and retrieve the local offset
  const { offset: localOffset } = utcDateTime.setZone("system", {
    keepLocalTime: true
  });

  // Subtract the local offset from the UTC date to get the local time
  let localDateTime;

  if (dateWithTime) {
    localDateTime =
      localOffset < 0
        ? utcDateTime.minus({ minutes: Math.abs(localOffset) })
        : utcDateTime.plus({ minutes: localOffset });
  } else {
    localDateTime = dateTime;
  }

  // Return the resulting local date in ISO format
  return localDateTime.toISO({ includeOffset: false });
};

export const humanReadableDate = (date) => {
  if (date) {
    const dateTime = DateTime.fromISO(date);
    const formattedString = dateTime.toFormat("yyyy-MM-dd");
    const dateWithTime = formattedString !== date;
    let localIsoDate = date;
    if(dateWithTime){
      localIsoDate = convertToLocalTime(date);
    }
    return DateTime.fromISO(localIsoDate, { zone: "utc" }).toFormat(
      "MM/dd/yyyy"
    );
  }
  return "";
};
